import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      email
      image
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      monday
      tuesday
      thursday
      wednesday
      friday
      saturday
      sunday
      night
      hours
      readedAt
      __typename
    }
  }
  `;

  export const getAgendaRequest = gql/* GraphQL */ `
  query GetAgendaRequest($requestId: ID!) {
    getAgendaRequest(requestId: $requestId) {
      comId
      createdAt
      deleted
      description
      requestId
      completed
      startAt
      stopAt
      accepted
      confirmed
      shift {
        accepted
        comId
        confirmed
        createdAt
        deleted
        info
        location
        role
        shiftId
        startAt
        stopAt
        suspended
        updatedAt
        userId
        username
        lat
        lng
        __typename
      }
      shiftId
      suggestedUser
      suggestedUserImage
      suggestedUserUsername
      type
      updatedAt
      user {
        FCMtoken
        comId
        createdAt
        email
        firstName
        friday
        hours
        image
        isConfirmed
        language
        lastName
        monday
        night
        password
        phoneNumber
        profileOwner
        readedAt
        role
        saturday
        sunday
        suspended
        thursday
        timezone
        tuesday
        type
        updatedAt
        userId
        username
        wednesday
        __typename
      }
      userId
      __typename
    }
  }
  `;

  export const requestsByUser = gql/* GraphQL */ `
  query RequestsByUser(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $userId: ID!
  ) {
    requestsByUser(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        comId
        completed
        createdAt
        deleted
        description
        requestId
        shiftId
        suggestedUser
        suggestedUserImage
        suggestedUserUsername
        type
        updatedAt
        userId
        startAt
        stopAt
        accepted
        confirmed
        shift {
          accepted
          comId
          confirmed
          createdAt
          deleted
          info
          location
          role
          shiftId
          startAt
          stopAt
          suspended
          updatedAt
          userId
          username
          lat
          lng
          __typename
        }
        user {
          comId
          image
          role
          type
          userId
          username
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

  export const requestsBySuggestedUser = gql/* GraphQL */ `
  query RequestsBySuggestedUser(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $suggestedUser: String!
  ) {
    requestsBySuggestedUser(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      suggestedUser: $suggestedUser
    ) {
      items {
        comId
        completed
        createdAt
        deleted
        description
        requestId
        shiftId
        suggestedUser
        suggestedUserImage
        suggestedUserUsername
        type
        updatedAt
        userId
        startAt
        stopAt
        accepted
        confirmed
        __typename
        shift {
          accepted
          comId
          confirmed
          createdAt
          deleted
          info
          location
          role
          shiftId
          startAt
          stopAt
          suspended
          updatedAt
          userId
          username
          lat
          lng
          __typename
        }
        user {
          comId
          image
          role
          type
          userId
          username
          __typename
        }
      }
      nextToken
      __typename
    }
  }
  `;

  export const requestsByComId = gql/* GraphQL */ `
  query RequestsByComId(
    $comId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    requestsByComId(
      comId: $comId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        comId
        completed
        createdAt
        deleted
        description
        requestId
        shiftId
        suggestedUser
        suggestedUserImage
        suggestedUserUsername
        type
        startAt
        stopAt
        accepted
        confirmed
        updatedAt
        userId
        shift {
          accepted
          comId
          confirmed
          createdAt
          deleted
          info
          location
          role
          shiftId
          startAt
          stopAt
          suspended
          updatedAt
          userId
          username
          lat
          lng
          __typename
        }
        user {
          comId
          image
          role
          type
          userId
          username
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

  export const createAgendaRequestByComId = gql/* GraphQL */ `
  mutation CreateAgendaRequestByComId(
    $comId: ID
    $completed: Boolean
    $createdAt: AWSDateTime
    $deleted: Boolean
    $description: String
    $requestId: ID!
    $shiftId: ID
    $startAt: AWSDateTime
    $stopAt: AWSDateTime
    $suggestedUser: String
    $suggestedUserImage: String
    $suggestedUserUsername: String
    $type: String
    $updatedAt: AWSDateTime
    $userId: ID
  ) {
    createAgendaRequestByComId(
      comId: $comId
      completed: $completed
      createdAt: $createdAt
      deleted: $deleted
      description: $description
      requestId: $requestId
      shiftId: $shiftId
      startAt: $startAt
      stopAt: $stopAt
      suggestedUser: $suggestedUser
      suggestedUserImage: $suggestedUserImage
      suggestedUserUsername: $suggestedUserUsername
      type: $type
      updatedAt: $updatedAt
      userId: $userId
    ) {
      comId
      completed
      createdAt
      deleted
      description
      requestId
      shift {
        accepted
        comId
        confirmed
        createdAt
        deleted
        info
        location
        role
        shiftId
        startAt
        stopAt
        suspended
        updatedAt
        userId
        username
        lat
        lng
        __typename
      }
      shiftId
      startAt
      stopAt
      accepted
      confirmed
      suggestedUser
      suggestedUserImage
      suggestedUserUsername
      type
      updatedAt
      user {
        FCMtoken
        comId
        createdAt
        email
        firstName
        friday
        hours
        image
        isConfirmed
        language
        lastName
        monday
        night
        password
        phoneNumber
        profileOwner
        readedAt
        role
        saturday
        sunday
        suspended
        thursday
        timezone
        tuesday
        type
        updatedAt
        userId
        username
        wednesday
        __typename
      }
      userId
      __typename
    }
  }
  `;

  export const usersByComId = gql/* GraphQL */ `
  query UsersByComId(
    $comId: ID!
    $filter: ModelAgendaUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    usersByComId(
      comId: $comId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        FCMtoken
        comId
        createdAt
        email
        firstName
        image
        isConfirmed
        language
        lastName
        password
        phoneNumber
        profileOwner
        readedAt
        role
        suspended
        type
        updatedAt
        userId
        username
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

  export const getAgendaShift = gql/* GraphQL */ `query GetAgendaShift($shiftId: ID!) {
  getAgendaShift(shiftId: $shiftId) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

  export const createAgendaRequest = gql/* GraphQL */ `
  mutation CreateAgendaRequest(
    $condition: ModelAgendaRequestConditionInput
    $input: CreateAgendaRequestInput!
  ) {
    createAgendaRequest(condition: $condition, input: $input) {
      comId
      completed
      createdAt
      deleted
      description
      requestId
      shift {
        accepted
        comId
        confirmed
        createdAt
        deleted
        info
        location
        role
        shiftId
        startAt
        stopAt
        suspended
        updatedAt
        userId
        username
        lat
        lng
        __typename
      }
      shiftId
      suggestedUser
      suggestedUserImage
      suggestedUserUsername
      type
      startAt
      stopAt
      accepted
      confirmed
      updatedAt
      user {
        FCMtoken
        comId
        createdAt
        email
        firstName
        friday
        hours
        image
        isConfirmed
        language
        lastName
        monday
        night
        password
        phoneNumber
        profileOwner
        readedAt
        role
        saturday
        sunday
        suspended
        thursday
        timezone
        tuesday
        type
        updatedAt
        userId
        username
        wednesday
        __typename
      }
      userId
      __typename
    }
  }
  `;

  export const onCreateAgendaRequestByCompanyId = gql/* GraphQL */ `
  subscription OnCreateAgendaRequestByCompanyId {
    onCreateAgendaRequestByCompanyId {
      accepted
      comId
      completed
      confirmed
      createdAt
      deleted
      description
      requestId
      shift {
        accepted
        comId
        confirmed
        createdAt
        deleted
        info
        location
        role
        shiftId
        startAt
        stopAt
        suspended
        updatedAt
        userId
        username
        lat
        lng
        __typename
      }
      shiftId
      startAt
      stopAt
      suggestedUser
      suggestedUserImage
      suggestedUserUsername
      type
      updatedAt
      user {
        FCMtoken
        comId
        createdAt
        email
        firstName
        friday
        hours
        image
        isConfirmed
        language
        lastName
        monday
        night
        password
        phoneNumber
        profileOwner
        readedAt
        role
        saturday
        sunday
        suspended
        thursday
        timezone
        tuesday
        type
        updatedAt
        userId
        username
        wednesday
        __typename
      }
      userId
      __typename
    }
  }
  `;

  export const updateAgendaShift = gql/* GraphQL */ `mutation UpdateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: UpdateAgendaShiftInput!
) {
  updateAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

  export const updateAgendaRequest = gql/* GraphQL */ `
  mutation UpdateAgendaRequest(
    $condition: ModelAgendaRequestConditionInput
    $input: UpdateAgendaRequestInput!
  ) {
    updateAgendaRequest(condition: $condition, input: $input) {
      comId
      completed
      createdAt
      deleted
      description
      requestId
      shift {
        accepted
        comId
        confirmed
        createdAt
        deleted
        info
        location
        role
        shiftId
        startAt
        stopAt
        suspended
        updatedAt
        userId
        username
        __typename
      }
      shiftId
      suggestedUser
      suggestedUserImage
      suggestedUserUsername
      type
      updatedAt
      user {
        FCMtoken
        comId
        createdAt
        email
        firstName
        friday
        hours
        image
        isConfirmed
        language
        lastName
        monday
        night
        password
        phoneNumber
        profileOwner
        readedAt
        role
        saturday
        sunday
        suspended
        thursday
        timezone
        tuesday
        type
        updatedAt
        userId
        username
        wednesday
        __typename
      }
      startAt
      stopAt
      accepted
      confirmed
      userId
      __typename
    }
  }
  `;